import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { usePlayerTrackInfo } from '@components/AudioPlayer/usePlayerTrackInfo';
import { FlexBetweenWrapper, SongInfoWrapper } from '@components/AudioPlayerMobile/shared';
import { LikeReleaseButton } from '@components/Likes/Button';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { useAudioController } from '@store/audio/AudioController';
import { webappUriPath } from '@utils/url';

export const SongInfo = ({ closePlayer }: { closePlayer: () => void }) => {
  const { activeTrackId } = useAudioController();

  const { releaseInfo } = usePlayerTrackInfo({
    trackId: activeTrackId,
    shouldFetch: true,
  });

  if (!releaseInfo) return null;

  const artistName = releaseInfo.artist.name ?? releaseInfo.artist.user.username;
  const songTitle = releaseInfo.title;

  const songUrl = webappUriPath(releaseInfo.webappUri);
  const artistUrl = webappUriPath(releaseInfo.artist.webappUri);

  return (
    <Container>
      <SongInfoWrapper>
        <AccessibleLink pathnameUri={songUrl} onClick={closePlayer}>
          <SongTitle>{songTitle}</SongTitle>
        </AccessibleLink>
        <AccessibleLink pathnameUri={artistUrl} onClick={closePlayer}>
          <ArtistName>{artistName}</ArtistName>
        </AccessibleLink>
      </SongInfoWrapper>
      <LikeReleaseButton
        variant="inverted"
        releaseId={releaseInfo.id}
        disabled={releaseInfo.type === 'ALBUM'}
        iconSize={24}
        source="Audio Player"
      />
    </Container>
  );
};

const Container = styled(FlexBetweenWrapper, {
  overflow: 'hidden',
  gap: 32,
  alignItems: 'center',
});

const SongTitle = styled('h3', {
  title: 'L',
  fontWeight: 500,
  color: '$white',
  whiteSpace: 'nowrap',
});

const ArtistName = styled('p', {
  base: 'S',
  fontWeight: 400,
  color: '$white',
  whiteSpace: 'nowrap',
});
